import LazyImg from 'App/Components/LazyImg';

import './styles.scss';

/**
 * Card component renders a single description card consisting of an image
 * and a text block (title + description). Used inside the landing game
 * description section.
 *
 * @param {string} src — Image source URL for the card illustration.
 * @param {string} alt — Alt text for the card image.
 * @param {number} width — Image width.
 * @param {number} height — Image height.
 * @param {string} title — Card heading text.
 * @param {import('react').ReactNode} description — Card body shown under the title.
 * @param {'when' | 'where'} modifier — Layout variant for this card.
 */

export const Card = ({ src, alt, width, height, title, description, modifier }) => {
    return (
        <div className={`description__item description__item--${modifier}`}>
            <div className={`description__image description__image--${modifier}`}>
                <LazyImg src={src} width={width} height={height} alt={alt} />
            </div>

            <div className={`description__content description__content--${modifier}`}>
                <h2 className='description__title'>{title}</h2>

                <div className='description__text'>{description}</div>
            </div>
        </div>
    );
};
